module.exports = __webpack_public_path__ + "static/media/app-shutdown-banner.8454f338.png";